import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CategoryCard = ({ category, large = false }) => {
  const defaultImage = 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=800';

  return (
    <Link
      to={`/category/${category.slug}`}
      className={`group relative block overflow-hidden ${large ? 'bento-large' : ''}`}
      data-testid={`category-card-${category.slug}`}
    >
      {/* Image */}
      <div className={`w-full h-full ${large ? 'min-h-[400px]' : 'min-h-[200px]'} overflow-hidden`}>
        <img
          src={category.image || defaultImage}
          alt={category.name}
          className="w-full h-full object-cover image-hover"
          loading="lazy"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 via-[#0A0A0A]/20 to-transparent" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-6">
        <span className="label-text mb-2">Collection</span>
        <h3 className={`text-white ${large ? 'heading-lg' : 'heading-md'} mb-2`}>
          {category.name}
        </h3>
        {category.description && (
          <p className="text-gray-300 text-sm mb-4 line-clamp-2 max-w-md">
            {category.description}
          </p>
        )}
        <span className="inline-flex items-center gap-2 text-[#C0C4CC] text-sm uppercase tracking-widest font-medium group-hover:gap-3 transition-all">
          Explore
          <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
};

export default CategoryCard;
